export default function Pill({ selected, children, className, onClick, size = "default", textCase = "uppercase" }) {
  const sizeClasses = size === "small"
    ? "px-3 py-1 gap-x-2 text-sm"
    : "px-4 py-2 gap-x-3";

  const caseClasses = textCase === "title" ? "capitalize" : "uppercase";

  return (
    <div
      className={`${caseClasses} border border-lz-candle-dim hover:cursor-pointer rounded-full flex items-center font-semibold ${sizeClasses} ${
        selected
          ? "bg-lz-candle-dim text-white dark:text-lz-concrete"
          : "bg-lz-paper-deep dark:bg-lz-ink-mid text-lz-ink-mid dark:text-lz-concrete hover:bg-lz-candle-dim hover:text-white dark:hover:text-lz-concrete"
      } ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
